<template>
    <div class="background somethingWentWrongPopup d-flex flex-column align-items-center justify-content-center" v-if="getIsShowingSomethingWentWrongPopup" @click.self="close">

        <div class="popup radius-normal">
            <div class="text-center fs-large darker bold pt-4 pb-2">
                Looks like something didn't go as expected, please contact our support team.
            </div>
            <div class="text-center p-4">
                    <button class="btn tertiary mr-2" @click="close">Close</button>
                    <button class="btn blue" @click="pressOk"><i class="fas fa-comment-alt"></i> Contact us</button>
            </div>
        </div>

    </div>
</template>

<script>
import { mapGetters, mapActions} from 'vuex'
export default {
    computed: {
        ...mapGetters([
            'getIsShowingSomethingWentWrongPopup'
        ])
    },
    methods: {
        ...mapActions([
            'showSomethingWentWrongPopup'
        ]),
        pressOk: function () {
            // window.location.href = "mailto:geral@pluralo.com?subject=Something went wrong";
            // this.showSomethingWentWrongPopup(false)
            this.$intercom.show()
            // this.close()
        },
        close: function () {
            this.showSomethingWentWrongPopup(false)
        }
    }
}
</script>

<style lang="scss" scoped>
.somethingWentWrongPopup{
    &.background{
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: rgba(0,0,0,0.5);
        z-index: 8000;
    }

    .popup{
        background-color: #FFF;
        width: 800px;
        // margin: auto;
        // top: 0;
        // bottom: 0;
        // right: 0;
        // left: 0;
        // height: 300px;
        // position: absolute;
    }
}
</style>



// WEBPACK FOOTER //
// SomethingWentWrong.vue?c8fcd046